module.exports = __webpack_public_path__ + "static/2018-10-30-PODCAST_Medication_Management_transcript-2558bc7ccbddccce64d6917054a6abb1.pdf";